import { h as s, defineComponent as a, Teleport as c, Fragment as r } from "vue";
const d = (e, t) => (o, n) => {
  const m = {
    Component: s(t, n),
    wrapperElement: o
  };
  e(m);
}, i = a({
  name: "ScheduleXCalendar",
  props: {
    calendarApp: {
      type: Object,
      required: !0
    },
    customComponents: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      elId: "sx" + Math.random().toString(36).substr(2, 9),
      customComponentsMeta: []
    };
  },
  mounted() {
    const e = {
      ...this.customComponents,
      ...this.$slots
    };
    for (const [t, o] of Object.entries(e))
      this.calendarApp._setCustomComponentFn(t, d(this.setCustomComponentMeta, o));
    this.calendarApp.render(document.getElementById(this.elId));
  },
  methods: {
    setCustomComponentMeta(e) {
      const t = [...this.customComponentsMeta], o = e.wrapperElement.dataset.ccid, n = t.find(({ wrapperElement: m }) => m.dataset.ccid === o);
      n && t.splice(t.indexOf(n), 1), this.customComponentsMeta = [...t, e];
    }
  },
  render() {
    const e = this.customComponentsMeta.map(({ Component: t, wrapperElement: o }) => s(c, { to: o }, t));
    return s("div", {
      id: this.elId,
      class: "sx-vue-calendar-wrapper"
    }, s(r, {}, e));
  }
});
export {
  i as ScheduleXCalendar
};
